document.addEventListener('DOMContentLoaded', function () {
  if (window.__shalemInit) return;
  window.__shalemInit = true;
  initReveal();
  initGaleria();
  initAcordeon();
  initUgcCarrusel();
  initSelectorProducto();
  initGarantiaCta();
  initContador();
  initStickyObserver();
  initWhatsappBuyBox();
  initPackSelectorV2();
});

function initReveal() {
  var els = document.querySelectorAll('.shalem-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('shalem-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('shalem-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });

  function revisarManual() {
    var alto = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      if (el.classList.contains('shalem-visible')) return;
      var r = el.getBoundingClientRect();
      if (r.top < alto * 0.9 && r.bottom > 0) {
        el.classList.add('shalem-visible');
        observer.unobserve(el);
      }
    });
  }
  window.addEventListener('scroll', revisarManual, { passive: true });
  window.addEventListener('resize', revisarManual);
  revisarManual();
  setTimeout(revisarManual, 800);

  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('shalem-visible'); });
  }, 4000);
}

function initGaleria() {
  document.querySelectorAll('[data-shalem-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-shalem-principal]');
    var minis = Array.prototype.slice.call(galeria.querySelectorAll('[data-shalem-mini]'));
    if (!principal || !minis.length) return;

    // Pide cada foto al ancho que realmente ocupa en pantalla, con los mismos anchos del srcset de la principal.
    function anchoAdaptado(src) {
      var px = (principal.clientWidth || 600) * Math.min(window.devicePixelRatio || 1, 2);
      var anchos = [360, 480, 600, 750, 900];
      var ancho = anchos[anchos.length - 1];
      for (var i = 0; i < anchos.length; i++) { if (anchos[i] >= px) { ancho = anchos[i]; break; } }
      return src.replace(/([?&])width=\d+/, '$1width=' + ancho);
    }
    minis.forEach(function (mini) {
      var src = mini.getAttribute('data-full');
      if (src) mini.setAttribute('data-full', anchoAdaptado(src));
    });

    var precargadas = {};
    function precargar() {
      minis.forEach(function (mini) {
        var src = mini.getAttribute('data-full');
        if (!src || precargadas[src]) return;
        var img = new Image();
        img.src = src;
        precargadas[src] = img;
      });
    }
    // La precarga espera a que la página termine de cargar para no competir con la imagen principal.
    function programarPrecarga() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(precargar, { timeout: 3000 });
      else setTimeout(precargar, 1500);
    }
    if (document.readyState === 'complete') programarPrecarga();
    else window.addEventListener('load', programarPrecarga, { once: true });

    function mostrar(src) {
      principal.removeAttribute('srcset');
      principal.src = src;
      principal.style.opacity = '1';
    }

    function irA(indice) {
      var mini = minis[indice];
      if (!mini) return;
      var src = mini.getAttribute('data-full');
      if (!src) return;
      minis.forEach(function (m) { m.classList.remove('shalem-mini-activa'); });
      mini.classList.add('shalem-mini-activa');

      var precargada = precargadas[src];
      if (precargada && precargada.complete) {
        mostrar(src);
        return;
      }
      principal.style.opacity = '0.4';
      if (precargada) {
        precargada.addEventListener('load', function () { mostrar(src); }, { once: true });
      } else {
        mostrar(src);
      }
    }

    minis.forEach(function (mini, indice) {
      mini.addEventListener('click', function () { irA(indice); });
    });

    function navegar(direccion) {
      var activa = minis.findIndex(function (m) { return m.classList.contains('shalem-mini-activa'); });
      if (activa === -1) activa = 0;
      var siguiente = (activa + direccion + minis.length) % minis.length;
      irA(siguiente);
    }

    var flechas = galeria.querySelectorAll('[data-shalem-flecha]');
    flechas.forEach(function (flecha) {
      flecha.addEventListener('click', function () {
        var direccion = flecha.getAttribute('data-shalem-flecha') === 'next' ? 1 : -1;
        navegar(direccion);
      });
    });

    // Swipe táctil nativo (sin librerías externas)
    var principalWrap = galeria.querySelector('.shalem-prod-principal-wrap');
    if (principalWrap && minis.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchDeltaX = 0;
      var esHorizontal = null;
      var UMBRAL_SWIPE = 50;

      principalWrap.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
        touchDeltaX = 0;
        esHorizontal = null;
      }, { passive: true });

      principalWrap.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        var deltaX = t.clientX - touchStartX;
        var deltaY = t.clientY - touchStartY;
        touchDeltaX = deltaX;

        if (esHorizontal === null && (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8)) {
          esHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
        }
        if (esHorizontal) {
          e.preventDefault();
        }
      }, { passive: false });

      principalWrap.addEventListener('touchend', function () {
        if (esHorizontal && Math.abs(touchDeltaX) >= UMBRAL_SWIPE) {
          navegar(touchDeltaX < 0 ? 1 : -1);
        }
        touchDeltaX = 0;
        esHorizontal = null;
        // Reanudar autoplay 8s después del swipe
        clearInterval(autoplayIntervalo);
        setTimeout(function () {
          if (!autoplayPausado) { autoplayIntervalo = setInterval(autoplayAvanzar, 3000); }
        }, 8000);
      });
    }

    // ─── Autoplay 3 s ──────────────────────────────────────────────────────
    if (minis.length > 1) {
      var autoplayIntervalo;
      var autoplayPausado = false;

      function autoplayAvanzar() {
        var activa = minis.findIndex(function (m) { return m.classList.contains('shalem-mini-activa'); });
        if (activa === -1) activa = 0;
        irA((activa + 1) % minis.length);
      }

      function autoplayIniciar() { autoplayIntervalo = setInterval(autoplayAvanzar, 3000); }
      function autoplayDetener() { clearInterval(autoplayIntervalo); }

      // Pausar en interacción táctil (ya se reanuda en touchend de arriba)
      if (principalWrap) {
        principalWrap.addEventListener('touchstart', function () {
          autoplayPausado = true;
          autoplayDetener();
        }, { passive: true });
      }

      // Pausar en clic en mini o flecha → reanudar 8 s después
      galeria.addEventListener('click', function () {
        autoplayDetener();
        setTimeout(function () { autoplayIntervalo = setInterval(autoplayAvanzar, 3000); }, 8000);
      });

      // El autoplay arranca con la primera interacción: durante la carga la imagen no cambia (LCP y Speed Index).
      var autoplayActivo = false;
      var eventosInicio = ['touchstart', 'scroll', 'pointerdown', 'keydown'];
      function activarAutoplay() {
        if (autoplayActivo) return;
        autoplayActivo = true;
        eventosInicio.forEach(function (ev) { window.removeEventListener(ev, activarAutoplay, true); });
        if (!autoplayPausado) autoplayIniciar();
      }
      eventosInicio.forEach(function (ev) { window.addEventListener(ev, activarAutoplay, { once: true, passive: true, capture: true }); });

      // Pausar cuando la pestaña pierde el foco
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { autoplayDetener(); }
        else if (autoplayActivo) { autoplayIniciar(); }
      });
    }
    // ─── Fin autoplay ───────────────────────────────────────────────────────
  });
}

function initAcordeon() {
  document.querySelectorAll('[data-shalem-acordeon]').forEach(function (acordeon) {
    var items = acordeon.querySelectorAll('[data-shalem-item]');
    items.forEach(function (item) {
      var pregunta = item.querySelector('[data-shalem-pregunta]');
      var respuesta = item.querySelector('[data-shalem-respuesta]');
      if (!pregunta || !respuesta) return;
      pregunta.addEventListener('click', function () {
        var abierto = item.classList.contains('shalem-item-abierto');
        items.forEach(function (i) {
          i.classList.remove('shalem-item-abierto');
          var r = i.querySelector('[data-shalem-respuesta]');
          if (r) r.style.maxHeight = null;
        });
        if (!abierto) {
          item.classList.add('shalem-item-abierto');
          respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        }
      });
    });
  });
}

function initUgcCarrusel() {
  document.querySelectorAll('[data-shalem-ugc]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-shalem-ugc-track]');
    var cards = Array.prototype.slice.call(wrap.querySelectorAll('.shalem-ugc-card'));
    if (!track || !cards.length) return;

    var indice = 0;

    function paso() {
      return cards[0].getBoundingClientRect().width + 12;
    }

    function mover() {
      indice = Math.max(0, Math.min(indice, cards.length - 1));
      track.style.transform = 'translateX(-' + (indice * paso()) + 'px)';
    }

    function navegar(direccion) {
      indice += direccion;
      mover();
    }

    wrap.querySelectorAll('[data-shalem-ugc-flecha]').forEach(function (flecha) {
      flecha.addEventListener('click', function () {
        var direccion = flecha.getAttribute('data-shalem-ugc-flecha') === 'next' ? 1 : -1;
        navegar(direccion);
      });
    });

    var touchStartX = 0;
    var touchStartY = 0;
    var touchDeltaX = 0;
    var esHorizontal = null;
    var UMBRAL_SWIPE = 50;

    track.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
      touchDeltaX = 0;
      esHorizontal = null;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      var deltaX = t.clientX - touchStartX;
      var deltaY = t.clientY - touchStartY;
      touchDeltaX = deltaX;
      if (esHorizontal === null && (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8)) {
        esHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
      }
      if (esHorizontal) {
        e.preventDefault();
      }
    }, { passive: false });

    track.addEventListener('touchend', function () {
      if (esHorizontal && Math.abs(touchDeltaX) >= UMBRAL_SWIPE) {
        navegar(touchDeltaX < 0 ? 1 : -1);
      }
      touchDeltaX = 0;
      esHorizontal = null;
    });

    window.addEventListener('resize', mover);
    mover();
  });
}

function initSelectorProducto() {
  document.querySelectorAll('[data-shalem-producto-form]').forEach(function (wrap) {
    var variantesData = wrap.querySelector('[data-shalem-variantes]');
    if (!variantesData) return;
    var variantes;
    try { variantes = JSON.parse(variantesData.textContent); } catch (e) { return; }

    var contenedor = wrap.closest('.shalem-prod-compra') || wrap;
    var fraganciaBtns = wrap.querySelectorAll('[data-shalem-fragancia]');
    var packBtns = wrap.querySelectorAll('[data-shalem-pack]');
    var idInput = wrap.querySelector('[data-shalem-variant-id]');
    var precioEl = contenedor.querySelector('[data-shalem-precio]');
    var comparePriceEl = contenedor.querySelector('[data-shalem-precio-tachado]');
    var descuentoEl = contenedor.querySelector('[data-shalem-descuento]');
    var submitBtn = wrap.querySelector('[data-shalem-submit]');
    var proxyBtn = document.querySelector('[data-shalem-cart-proxy]');
    var proxyPrecioEl = document.querySelector('[data-shalem-precio-movil]');
    var proxyPackEl = document.querySelector('[data-shalem-pack-movil]');
    var proxyMontoEl = document.querySelector('[data-shalem-monto-movil]');
    var proxyAhorroEl = document.querySelector('[data-shalem-ahorro-movil]');
    var surtidoAvisoEl = wrap.querySelector('[data-shalem-surtido-aviso]');

    var estado = { fragancia: null, pack: null };
    var elegido = { fragancia: false, pack: false };
    var activoF = wrap.querySelector('[data-shalem-fragancia].shalem-opcion-activa');
    var activoP = wrap.querySelector('[data-shalem-pack].shalem-opcion-activa');
    if (activoF) estado.fragancia = activoF.getAttribute('data-shalem-fragancia');
    if (activoP) estado.pack = activoP.getAttribute('data-shalem-pack');

    function formatoCOP(centavos) {
      var pesos = Math.round(centavos / 100);
      return '$' + pesos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function actualizar() {
      // ═══ La oferta real: $139.800 = 2 x $69.900, es decir 3 frascos pagando 2.
      // El ancla de Shopify ($195.000) no cuenta esa historia, asi que para el pack
      // de 3 se calcula el ancla como 3 x precio unitario = $209.700, con lo que el
      // ahorro da exactamente un frasco completo. Se computa en el tema: NO se toca
      // el producto, que es compartido con el tema en vivo.
      function unidadesDe(pack) { return /3 UNIDADES|3 unidades/.test(pack || "") ? 3 : 1; }
      function precioUnitarioBase() {
        var base = variantes.find(function (v) { return unidadesDe(v.pack) === 1; });
        return base ? base.price : 6990000;
      }
      function ofertaDe(m) {
        var u = unidadesDe(m.pack);
        var ancla = u > 1 ? precioUnitarioBase() * u : m.compare_at_price;
        return { unidades: u, precio: m.price, ancla: ancla,
                 ahorro: (ancla && ancla > m.price) ? ancla - m.price : 0,
                 unitario: Math.round(m.price / u) };
      }
      if (!estado.fragancia || !estado.pack) return;
      var match = variantes.find(function (v) {
        return v.fragancia === estado.fragancia && v.pack === estado.pack;
      });
      if (!match) return;
      var oferta = ofertaDe(match);
      if (idInput) idInput.value = match.id;
      if (precioEl) precioEl.textContent = formatoCOP(oferta.precio);
      if (comparePriceEl) {
        if (oferta.ancla > oferta.precio) {
          comparePriceEl.textContent = formatoCOP(oferta.ancla);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (descuentoEl) {
        if (oferta.ahorro > 0) {
          descuentoEl.textContent = 'AHORRAS ' + formatoCOP(oferta.ahorro);
          descuentoEl.style.display = '';
        } else {
          descuentoEl.style.display = 'none';
        }
      }
      // CAMBIO 4 — precio por frasco, solo cuando la cantidad es mayor a 1
      var unitEl = document.querySelector('[data-shalem-unitario]');
      if (unitEl) {
        if (oferta.unidades > 1) {
          unitEl.innerHTML = 'Te sale a <strong>' + formatoCOP(oferta.unitario) + '</strong> cada frasco';
          unitEl.hidden = false;
        } else {
          unitEl.hidden = true;
        }
      }
      var surtidoBloqueado = estado.fragancia === 'Surtido' && estado.pack.indexOf('Inicio') !== -1;
      if (surtidoAvisoEl) {
        surtidoAvisoEl.hidden = !surtidoBloqueado;
      }
      // C1 — la nota del Surtido solo aparece cuando esa fragancia esta elegida.
      var notaSurtido = document.querySelector("[data-shalem-nota-surtido]");
      // CAMBIO 5 — la nota existe cuando Surtido es visible; se resalta si esta elegido.
      if (notaSurtido) {
        var surtidoBtn = document.querySelector(".shalem-frag-surtido");
        var surtidoVisible = surtidoBtn && !surtidoBtn.classList.contains("shalem-frag-oculto");
        notaSurtido.hidden = !surtidoVisible;
        notaSurtido.classList.toggle("shalem-nota-activa", estado.fragancia === "Surtido");
      }
      // CTA de dos lineas: linea 1 = label + precio + ancla, linea 2 = garantia.
      // Al crear .shalem-btn-l1 aqui, la guarda de pintar() en shalem-compra.js
      // hace que ese script no vuelva a sobrescribir el boton.
      function pintarCTA(btn, label, conPrecio) {
        if (!btn) return;
        btn.textContent = '';
        var l1 = document.createElement('span');
        l1.className = 'shalem-btn-l1';
        l1.appendChild(document.createTextNode(conPrecio ? label + ' — ' : label));
        if (conPrecio) {
          var sp = document.createElement('span');
          sp.className = 'shalem-btn-precio';
          sp.textContent = formatoCOP(match.price);
          l1.appendChild(sp);
          if (oferta.ahorro > 0) {
            var an = document.createElement('span');
            an.className = 'shalem-btn-antes';
            an.textContent = formatoCOP(oferta.ancla);
            l1.appendChild(an);
          }
        }
        btn.appendChild(l1);
        if (conPrecio) {
          var l2 = document.createElement('span');
          l2.className = 'shalem-btn-l2';
          l2.innerHTML = '<svg class="shalem-btn-escudo" viewBox="0 0 24 24" width="14" height="14" fill="none" ' +
            'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M12 2l8 4v6c0 5-3.4 8.7-8 10-4.6-1.3-8-5-8-10V6l8-4z"/></svg>' +
            '<span>Garantía de 30 días</span>';
          btn.appendChild(l2);
        }
      }
      if (submitBtn) {
        if (!elegido.fragancia || !elegido.pack) {
          submitBtn.disabled = true;
          pintarCTA(submitBtn, submitBtn.getAttribute('data-texto-elige'), false);
        } else if (surtidoBloqueado) {
          submitBtn.disabled = true;
          pintarCTA(submitBtn, submitBtn.getAttribute('data-texto-disponible'), true);
        } else {
          submitBtn.disabled = !match.available;
          if (match.available) {
            pintarCTA(submitBtn, submitBtn.getAttribute('data-texto-disponible'), true);
          } else {
            pintarCTA(submitBtn, submitBtn.getAttribute('data-texto-agotado'), false);
          }
        }
      }
      var completo = elegido.fragancia && elegido.pack;
      if (proxyBtn && !proxyBtn.classList.contains('shalem-btn-agregando')) {
        if (!completo) {
          proxyBtn.textContent = proxyBtn.getAttribute('data-texto-elige-ambos');
        } else if (surtidoBloqueado) {
          proxyBtn.textContent = proxyBtn.getAttribute('data-texto-disponible');
        } else {
          proxyBtn.textContent = match.available
            ? proxyBtn.getAttribute('data-texto-disponible')
            : submitBtn.getAttribute('data-texto-agotado');
        }
        proxyBtn.disabled = completo && submitBtn ? submitBtn.disabled : false;
      }
      if (proxyPrecioEl) {
        // P2 — sticky con 3 datos: pack seleccionado | precio | ahorro + envio gratis
        if (proxyMontoEl) {
          proxyMontoEl.textContent = formatoCOP(match.price);
        } else {
          proxyPrecioEl.textContent = completo ? formatoCOP(match.price) : 'Desde ' + formatoCOP(match.price);
        }
        if (proxyPackEl) {
          proxyPackEl.textContent = completo && estado.pack ? estado.pack : 'Elige tu pack';
        }
        if (proxyAhorroEl) {
          var ahorroCent = oferta.ahorro > 0
            ? oferta.ahorro : 0;
          proxyAhorroEl.textContent = ahorroCent > 0
            ? 'Ahorras ' + formatoCOP(ahorroCent) + ' + envío gratis'
            : 'Envío gratis';
        }
        proxyPrecioEl.classList.toggle('shalem-mobile-precio-generico', !completo);
      }
    }

    function scrollSuaveHasta(el) {
      if (!el) return;
      try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      var destino = el.getBoundingClientRect().top + window.pageYOffset - (window.innerHeight / 2) + (el.offsetHeight / 2);
      window.scrollTo({ top: destino, behavior: 'smooth' });
      el.classList.remove('shalem-highlight-pulso');
      void el.offsetWidth;
      el.classList.add('shalem-highlight-pulso');
      setTimeout(function () { el.classList.remove('shalem-highlight-pulso'); }, 1000);
    }

    if (proxyBtn) {
      proxyBtn.addEventListener('click', function () {
        if (!elegido.fragancia) {
          scrollSuaveHasta(document.querySelector('[data-shalem-target-fragancia]'));
          return;
        }
        if (!elegido.pack) {
          scrollSuaveHasta(document.querySelector('[data-shalem-target-pack]'));
          return;
        }
        if (submitBtn && !submitBtn.disabled) {
          submitBtn.click();
          var textoOriginal = proxyBtn.textContent;
          proxyBtn.classList.add('shalem-btn-agregando');
          proxyBtn.textContent = proxyBtn.getAttribute('data-texto-agregado');
          setTimeout(function () {
            proxyBtn.classList.remove('shalem-btn-agregando');
            proxyBtn.textContent = textoOriginal;
          }, 1500);
        }
      });
    }

    var form = wrap.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!idInput || !idInput.value) return;
        if (window.ShalemCart) {
          window.ShalemCart.agregar(idInput.value, 1);
        } else {
          form.submit();
        }
      });
    }

    fraganciaBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        fraganciaBtns.forEach(function (b) { b.classList.remove('shalem-opcion-activa'); });
        btn.classList.add('shalem-opcion-activa');
        estado.fragancia = btn.getAttribute('data-shalem-fragancia');
        elegido.fragancia = true;
        actualizar();
      });
    });
    packBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        packBtns.forEach(function (b) { b.classList.remove('shalem-opcion-activa'); });
        btn.classList.add('shalem-opcion-activa');
        estado.pack = btn.getAttribute('data-shalem-pack');
        elegido.pack = true;
        actualizar();
      });
    });

    actualizar();
  });
}

function initStickyObserver() {
  var mainATC = document.querySelector('[data-main-atc-button]');
  var sticky = document.getElementById('shalem-sticky');
  var urgency = document.getElementById('shalem-urgency');
  if (!mainATC || !sticky) return;

  function set(visible) {
    sticky.classList.toggle('visible', visible);
    if (urgency) urgency.classList.toggle('visible', visible);
  }

  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    set(!entry.isIntersecting);
  }, { threshold: 0 });
  observer.observe(mainATC);

  var revisando = false;
  function revisarManual() {
    var r = mainATC.getBoundingClientRect();
    var enViewport = r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    set(!enViewport);
    revisando = false;
  }
  window.addEventListener('scroll', function () {
    if (revisando) return;
    revisando = true;
    requestAnimationFrame(revisarManual);
  }, { passive: true });
  window.addEventListener('resize', revisarManual);
  revisarManual();
}

function initGarantiaCta() {
  var btn = document.querySelector('[data-shalem-garantia-cta]');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var destino = document.querySelector('[data-shalem-target-pack]');
    if (!destino) return;
    try { destino.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    var top = destino.getBoundingClientRect().top + window.pageYOffset - (window.innerHeight / 2) + (destino.offsetHeight / 2);
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
}

function initContador() {
  document.querySelectorAll('[data-shalem-contador]').forEach(function (el) {
    var target = parseInt(el.getAttribute('data-shalem-contador'), 10);
    if (isNaN(target)) return;
    var animado = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !animado) {
          animado = true;
          var start = 0;
          var duration = 1200;
          var startTime = null;
          function paso(ts) {
            if (!startTime) startTime = ts;
            var progreso = Math.min((ts - startTime) / duration, 1);
            el.textContent = Math.floor(progreso * target).toString();
            if (progreso < 1) requestAnimationFrame(paso);
            else el.textContent = target.toString();
          }
          requestAnimationFrame(paso);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    observer.observe(el);
  });
}

/* D6 — el boton de WhatsApp se oculta mientras el buy box esta en pantalla,
   para no taparse con la grilla de aromas ni con las filas de pack.
   Reaparece apenas el buy box sale del viewport. Solo en movil. */
function initWhatsappBuyBox() {
  var wa = document.querySelector('.shalem-wa-flotante');
  var buybox = document.querySelector('.shalem-zona-oscura');
  if (!wa || !buybox || !window.IntersectionObserver) return;
  if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;
  wa.style.transition = 'opacity .2s ease, transform .2s ease';
  new IntersectionObserver(function (entries) {
    var dentro = entries[0].isIntersecting;
    wa.style.opacity = dentro ? '0' : '1';
    wa.style.pointerEvents = dentro ? 'none' : 'auto';
    wa.style.transform = dentro ? 'scale(.85)' : 'scale(1)';
  }, { threshold: 0 }).observe(buybox);
}

/* ══════════════════════════════════════════════════════════════════════
   CAMBIOS 2-5 — una decision a la vez.
   El contador NO toca la logica de variantes: acciona los botones de pack
   que ya existen, asi que el matching de variante y el carrito no cambian.
   IMPORTANTE: en Shopify solo existen 2 packs (1 unidad y 3 unidades).
   No hay variante de 2, asi que el contador tiene dos paradas: 1 y 3.
   ══════════════════════════════════════════════════════════════════════ */
function initPackSelectorV2() {
  // ─── Countdown de sesión (10 min, sessionStorage) ─────────────────────────
  (function () {
    var KEY = 'shalem_countdown_end';
    var DURACION = 6 * 60 * 60 * 1000;
    var contenedor = document.getElementById('shalem-countdown');
    var display = document.getElementById('shalem-countdown-tiempo');
    if (!contenedor || !display) return;
    var fin = parseInt(sessionStorage.getItem(KEY), 10);
    if (!fin || isNaN(fin) || fin < Date.now()) {
      fin = Date.now() + DURACION;
      try { sessionStorage.setItem(KEY, String(fin)); } catch (e) {}
    }
    function tick() {
      var resto = fin - Date.now();
      if (resto <= 0) { contenedor.hidden = true; return; }
      var h = Math.floor(resto / 3600000);
      var m = Math.floor((resto % 3600000) / 60000);
      var s = Math.floor((resto % 60000) / 1000);
      display.textContent = String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
      contenedor.hidden = false;
    }
    tick();
    setInterval(tick, 1000);
  })();

  // ─── Pack selector v2 ────────────────────────────────────────────────────
  var opciones = [].slice.call(document.querySelectorAll('.shalem-pack-v2-opcion'));
  if (!opciones.length) return;

  function actualizarNotaSurtido(opcionEl, fragancia) {
    var nota = opcionEl.querySelector('[data-shalem-surtido-nota-v2]');
    if (nota) nota.hidden = fragancia !== 'Surtido';
  }

  function activarOpcion(opcionEl) {
    opciones.forEach(function (o) {
      var activo = o === opcionEl;
      o.classList.toggle('shalem-pack-v2-activo', activo);
      var pills = o.querySelector('.shalem-aroma-pills');
      if (pills) pills.hidden = !activo;
    });
    // Disparar el trigger oculto para sincronizar actualizar()
    var trigger = opcionEl.querySelector('[data-shalem-pack]');
    if (trigger) trigger.click();
    // Auto-seleccionar primera fragancia si ninguna está activa en este pack
    var pillsDiv = opcionEl.querySelector('.shalem-aroma-pills');
    if (pillsDiv) {
      var yaActiva = pillsDiv.querySelector('[data-shalem-fragancia].shalem-opcion-activa');
      var destino = yaActiva || pillsDiv.querySelector('[data-shalem-fragancia]');
      if (destino) destino.click();
    }
  }

  opciones.forEach(function (opcion) {
    // Clic en el contenedor (radio) activa el pack
    opcion.addEventListener('click', function (e) {
      if (e.target.closest('[data-shalem-fragancia]')) return;
      if (!opcion.classList.contains('shalem-pack-v2-activo')) {
        activarOpcion(opcion);
      }
    });

    // Clic en pills de aroma dentro de este pack
    var pills = [].slice.call(opcion.querySelectorAll('[data-shalem-fragancia]'));
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        // Activar visualmente solo dentro de este pack
        pills.forEach(function (p) { p.classList.remove('shalem-opcion-activa'); });
        pill.classList.add('shalem-opcion-activa');
        actualizarNotaSurtido(opcion, pill.getAttribute('data-shalem-fragancia'));
      });
    });
  });

  // Auto-activar primera opción al cargar (Pack Inicio + Maracuyá)
  activarOpcion(opciones[0]);
}
